import { UsersTypes } from '@frontend/user-helpers';
import { customContextFactory } from '../../../../../../hooks';

type ContextType = {
  locationUsers?: UsersTypes.User[];
  refetchScheduleRequestList: () => void;
};

export const [ScheduleRequestContextProvider, useScheduleRequestContext] = customContextFactory<ContextType>();
